import { render, staticRenderFns } from "./SalaryBatches.vue?vue&type=template&id=16d698de&scoped=true"
import script from "./SalaryBatches.vue?vue&type=script&lang=js"
export * from "./SalaryBatches.vue?vue&type=script&lang=js"
import style0 from "./SalaryBatches.vue?vue&type=style&index=0&id=16d698de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d698de",
  null
  
)

export default component.exports